var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowReturnLeftOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.6303 2.7197a.75.75 0 0 1 0 1.0606L5.8107 5.6H11.05c3.01 0 5.45 2.44 5.45 5.45 0 3.01-2.44 5.45-5.45 5.45H6.4a.75.75 0 0 1 0-1.5h4.65c2.1815 0 3.95-1.7685 3.95-3.95S13.2315 7.1 11.05 7.1H5.8107l1.8196 1.8196a.75.75 0 0 1-1.0606 1.0607l-3.1-3.1a.75.75 0 0 1 0-1.0606l3.1-3.1a.75.75 0 0 1 1.0606 0Z",
  clipRule: "evenodd"
})));
export { SvgArrowReturnLeftOutline20 as ReactComponent };